// extracted by mini-css-extract-plugin
export var dividerLine = "_8h-3";
export var itemImage = "_8h-9";
export var lightDivider = "_8h-4";
export var modalContent = "_8h-5";
export var modalContentCompact = "_8h-6";
export var productCard = "_8h-a";
export var productImage = "_8h-b";
export var productImageCompact = "_8h-7";
export var productImagePlaceholder = "_8h-c";
export var productImagePlaceholderCompact = "_8h-8";
export var progressBarBackground = "_8h-1";
export var progressBarContainer = "_8h-0";
export var progressBarFill = "_8h-2";